module.exports = __webpack_public_path__ + "media/Indoor basketballs.9cb02f88.mp4";